// Arsenal de Allende — datos de la página Temporada Septiembre 2026.
// Fuente única de esta página (la de la temporada anterior sigue usando arsenalData.js).

export const club = {
  name: "Arsenal de Allende",
  slogan: "La historia no se hereda, se escribe en cada torneo.",
  founded: 2013, // el escudo nuevo dice "Fundado 2013" (el sitio anterior decía 2012)
  titles: 3,
  category: "Primera División Local",
  modality: "Fútbol 7",
  matchday: "Lunes, entre 7 y 11 pm (horario por sorteo)",
  venue: "Canchas Colonias del Norte, Allende, N.L.",
  email: "contacto@arsenaldeallende.com",
  phone: "+52 826 166 6837",
  facebook: "https://www.facebook.com/arsenaldeallende",
};

export const seasonLabel = "Temporada septiembre 2026";

// Próximo partido: la app de la liga no muestra fecha ni hora (se sortea cada semana).
// TODO(cliente): con `date` en ISO (ej. "2026-10-19T19:00:00-06:00") aparece el contador.
export const nextMatch = {
  date: null,
  rival: "Sordeados",
  jornada: 5,
  venue: club.venue,
};

const PHOTOS = "/temporada-sep26/jugadores";

export const goalkeeper = { name: "Adán", number: "1", role: "Portero", photo: `${PHOTOS}/adan.jpg` };

// Faltan fotos de Cedillo (#4) y Tata (#13).
export const players = [
  { name: "Giezi", number: "14", photo: `${PHOTOS}/giezi.jpg` },
  { name: "Cedillo", number: "4" },
  { name: "Zurdo", number: "7", photo: `${PHOTOS}/zurdo.jpg` },
  { name: "Tata", number: "13" },
  { name: "Tacher", number: "9", photo: `${PHOTOS}/tacher.jpg` },
  { name: "Emmanuel", number: "22", photo: `${PHOTOS}/emmanuel.jpg` },
  { name: "Tamez", number: "18", photo: `${PHOTOS}/tamez18.jpg` },
  { name: "L. Cavazos", number: "10", photo: `${PHOTOS}/cavazos.jpg` },
  { name: "Iván Morales", number: "3", photo: `${PHOTOS}/ivan.jpg` },
  { name: "Rojas", number: "11", photo: `${PHOTOS}/rojas.jpg` },
  { name: "Pecha", number: "8", photo: `${PHOTOS}/pecha.jpg` },
  { name: "Daniel Guerra", number: "12", photo: `${PHOTOS}/dguerra.jpg` },
  { name: "Osvaldo L.", number: "5", photo: `${PHOTOS}/osvaldo.jpg` },
  { name: "H. Tamez", number: "30", photo: `${PHOTOS}/htamez.jpg` },
].sort((a, b) => Number(a.number) - Number(b.number));

export const coach = { name: "Luis Tamez", role: "Director técnico", photo: `${PHOTOS}/dt.jpg` };

export const squad = [goalkeeper, ...players, { ...coach, number: "DT" }];

// ── Historia: tomada del sitio anterior. La fundación sigue el escudo (2013), así que
// los hitos 2012 → 2013 y "10 años" → 2023. TODO(cliente): confirmar fechas.
export const timeline = [
  {
    year: "2013",
    title: "Fundación del Club",
    description: "Nace Arsenal de Allende con la visión de unir a una comunidad a través del fútbol. Un grupo de amigos con una pasión en común.",
  },
  {
    year: "2013",
    title: "Primer Torneo Ganado",
    description: "El primer trofeo en el año de fundación. Un comienzo de leyenda que marcó la identidad ganadora del club.",
  },
  {
    year: "2023",
    title: "10 Años de Gloria",
    description: "Celebración de una década construyendo identidad, hermandad y una cultura ganadora.",
  },
  {
    year: "2025",
    title: "Tercer Campeonato",
    description: "El 20 de marzo, Arsenal conquista su tercer título venciendo a Robalo's. Otra noche para la historia arsenalista.",
    galleryLabel: "Ver galería del campeonato",
    galleryImages: [1, 2, 3, 4, 5].map((n) => `/historia/2025/foto${n}.jpg`),
  },
  {
    year: "2026",
    title: "Nueva Era Digital",
    description: "Arsenal lanza su portal oficial para conectar con aficionados y compartir cada momento del equipo.",
  },
];

// ── Temporada actual. Calendario tomado de capturas de la app de la liga (sin fechas).
// Las jornadas siguen el orden en que aparecen en la app. TODO(cliente): agregar `date` ISO.
// schedule: { id, jornada, date (ISO|null), home, away, status: "played"|"upcoming"|"cancelled", score: "local-visita" }
export const schedule = [
  { id: 1, jornada: 1, date: null, home: "Arsenal", away: "Galax", status: "played", score: "4-4" },
  { id: 2, jornada: 2, date: null, home: "Servi Bar", away: "Arsenal", status: "played", score: "0-3" },
  { id: 3, jornada: 3, date: null, home: "Arsenal", away: "Tuzos", status: "played", score: "6-5" },
  { id: 4, jornada: 4, date: null, home: "Arsenal", away: "JT Carnes", status: "played", score: "3-8" },
  { id: 5, jornada: 5, date: null, home: "Sordeados", away: "Arsenal", status: "upcoming" },
  { id: 6, jornada: 6, date: null, home: "Arsenal", away: "Xolos", status: "upcoming" },
  { id: 7, jornada: 7, date: null, home: "Manchester City", away: "Arsenal", status: "upcoming" },
  { id: 8, jornada: 8, date: null, home: "Canito's", away: "Arsenal", status: "upcoming" },
  { id: 9, jornada: 9, date: null, home: "Arsenal", away: "Cuadro Chico", status: "upcoming" },
  { id: 10, jornada: 10, date: null, home: "Descanchados", away: "Arsenal", status: "upcoming" },
];
// Tabla general: copafacil.com (Unidad Deportiva Colonias del Norte · Primera, lunes · 1ª fase).
// standings: { pos, team, pj, g, e, p, gf, gc, dif, pts, pct } · actualizado tras la jornada 4 de Arsenal.
export const standings = [
  { pos: 1, team: "Xolos", pj: 4, g: 4, e: 0, p: 0, gf: 26, gc: 7, dif: 19, pts: 12, pct: 100 },
  { pos: 2, team: "Sordeados", pj: 4, g: 3, e: 1, p: 0, gf: 19, gc: 7, dif: 12, pts: 10, pct: 83 },
  { pos: 3, team: "JT Carnes", pj: 3, g: 3, e: 0, p: 0, gf: 21, gc: 7, dif: 14, pts: 9, pct: 100 },
  { pos: 4, team: "Arsenal", pj: 4, g: 2, e: 1, p: 1, gf: 16, gc: 17, dif: -1, pts: 7, pct: 58 },
  { pos: 5, team: "Cuadro Chico", pj: 3, g: 1, e: 1, p: 1, gf: 5, gc: 9, dif: -4, pts: 4, pct: 44 },
  { pos: 6, team: "Canito's", pj: 3, g: 1, e: 1, p: 1, gf: 9, gc: 15, dif: -6, pts: 4, pct: 44 },
  { pos: 7, team: "Manchester City", pj: 4, g: 1, e: 0, p: 3, gf: 14, gc: 14, dif: 0, pts: 3, pct: 25 },
  { pos: 8, team: "Tuzos", pj: 4, g: 1, e: 0, p: 3, gf: 14, gc: 16, dif: -2, pts: 3, pct: 25 },
  { pos: 9, team: "Descanchados", pj: 3, g: 1, e: 0, p: 2, gf: 4, gc: 22, dif: -18, pts: 3, pct: 33 },
  { pos: 10, team: "Servi Bar", pj: 4, g: 0, e: 1, p: 3, gf: 10, gc: 17, dif: -7, pts: 1, pct: 8 },
  { pos: 11, team: "Galax", pj: 4, g: 0, e: 1, p: 3, gf: 10, gc: 17, dif: -7, pts: 1, pct: 8 },
];
// lastMatch: { competition, home: { name, score }, away: { name, score }, scorers?: [{ player, minute }] }
export const lastMatch = {
  competition: `${club.category} · Jornada 4`,
  home: { name: "Arsenal", score: 3 },
  away: { name: "JT Carnes", score: 8 },
  scorers: [],
};
// topScorers: { name, nickname, goals, matches } · topAssists: { name, nickname, assists, matches }
export const topScorers = [];
export const topAssists = [];

export const currentTournament = {
  name: `${club.category} · ${club.modality}`,
  season: seasonLabel,
  status: "En curso",
};

export const kitSpecs = [
  { title: "Versión de jugador", text: "Corte y tela de edición de jugador, con tecnología heat-pressed." },
  { title: "Patrón geométrico", text: "Azul profundo con detalles en oro y cuello en rojo." },
  { title: "Escudo exclusivo", text: "Con la tradición de Allende, N.L.: montaña, azahar y cañón." },
];

export const assets = {
  crest: "/temporada-sep26/escudo.png",
  heroVideo: "/temporada-sep26/hero-equipo.mp4",
  ambientVideo: "/temporada-sep26/hero.mp4",
  reelVideo: "/temporada-sep26/reel.mp4",
  reelPoster: "/temporada-sep26/reel-poster.jpg",
  heroPoster: "/temporada-sep26/hero-equipo-poster.jpg",
  heroBg: "/temporada-sep26/hero-fondo.mp4",
  heroBgPoster: "/temporada-sep26/hero-fondo-poster.jpg",
  cancha: "/temporada-sep26/cancha.jpg",
  kitVideo: "/temporada-sep26/traje.mp4",
  kitPoster: "/temporada-sep26/vestuario.jpg",
  kitSheet: "/temporada-sep26/traje-ficha.jpg",
  teamA: "/temporada-sep26/equipo-1.jpg",
  teamB: "/temporada-sep26/equipo-2.jpg",
  stadium: "/temporada-sep26/estadio.jpg",
  tunnel: "/temporada-sep26/tunel.jpg",
  smoke: "/temporada-sep26/humo.jpg",
};
